module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Light.eot
// module id = 1899
// module chunks = 0